import { combineReducers } from 'redux';
import appBarReducer from './headervar_reducer';
import blogReducer from './blog_reducer';
import paymentReducer from './payment_reducer';
import homePageReducer from './home_page_reducer';
import announcementReducer from './announcement_reducer';

const reducerList = combineReducers({
  appBarReducer,
  blogReducer,
  paymentReducer,
  homePageReducer,
  announcementReducer
});

export default reducerList;
